import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/contact.svg',
})
export class ContactComponent {}
